import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';

import type {QueryEntrySection} from '../index';
import {QuerySuperEntry} from '../types';

export function RowLabel({
  el,
  index,
  isPlaceholder,
}: {
  el: QueryEntrySection;
  entry: QuerySuperEntry;
  index: number;
  isPlaceholder: boolean;
}) {
  const isClickable = !isPlaceholder && el.attr(`row-index-toggleable`);
  const prefix = el.helpers.getRowLabelPrefix(index);
  const hasPrefix = prefix !== undefined;

  return (
    <>
      {/** optional prefixed grouped label */}
      {hasPrefix ? (
        <>
          <RowLabelContent
            label={prefix}
            isPlaceholder={isPlaceholder}
            clickHandler={isClickable && el.helpers.onGroupEntryIndexLabelClicked.bind(el)}
          />
        </>
      ) : null}
      <RowLabelContent
        label={el.helpers.getRowLabel(index)}
        isPlaceholder={isPlaceholder}
        clickHandler={isClickable && !hasPrefix && el.helpers.onEntryIndexLabelClicked.bind(el, index)}
      />
    </>
  );
}

function RowLabelContent({
  label,
  isPlaceholder,
  clickHandler,
}: {
  label: string;
  isPlaceholder: boolean;
  clickHandler: (ev: MouseEvent) => void;
}) {
  return (
    <div sel='.mp-query-entry-label' class={{'is-placeholder': isPlaceholder}} attrs={{elref: `rowLabel`}}>
      {label && (
        <ButtonEl
          attrs={{
            elref: `rowLabelButton`,
            theme: ButtonTheme.Tertiary,
          }}
          class={{'is-clickable': Boolean(clickHandler)}}
          on={{click: clickHandler}}
        >
          {label}
        </ButtonEl>
      )}
    </div>
  );
}
